import React, { Fragment } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  CardActionArea,
  Button,
} from "@mui/material";
import { useQuery } from "react-query";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { getSimulationsData } from "../../services/cluster";
import { grey } from "@mui/material/colors";
import Check from "../../auth/ability";
import { CAN, SUBJECTS } from "../../auth/permissions";
import { MODULES } from "../../services/Constants";
import useModule from "../../hooks/useModule";
import ClusterSimulationFileUploadDialog from "../clusterSimulations/ClusterSimulationFileUploadDialog";
import ClusterFileUpload from "../clusterSimulations/ClusterFileUpload";
import DottedTile from "../common/DottedTile";
import InfoTile from "../common/InfoTile";

const ToolImageStats = () => {
  const { validateModuleWithMessage } = useModule();
  const { data: { data: { simulations = 0 } = {} } = {} } = useQuery(
    ["getSimulationsReport", { simulationType: "TOOL" }],
    getSimulationsData,
    {
      refetchOnWindowFocus: false,
    }
  );

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
    width: 800,
    height: 400,
    bgcolor: "background.paper",
    outline: 0,
    p: 4,
  };

  const [openModal, setOpenModal] = React.useState(false);
  const handleOpen = () => {
    if (!validateModuleWithMessage(MODULES.OTA)) return;
    setOpenModal(true);
  };
  const handleClose = () => setOpenModal(false);

  return (
    <Fragment>
      <Grid size={{ xs: 2, sm: 12, md: 12, lg: 12 }} >
        <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2 }} >
          <InfoTile title={"Total Tools"} info={simulations || "0"} />
        </Grid>
      </Grid>
      <Grid size={{ xs: 2, sm: 12, md: 12, lg: 12 }} >
        <Check I={CAN.CREATE} a={SUBJECTS.IMAGE}>
          <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2 }} >
            <CardActionArea onClick={handleOpen}>
              <Button
                variant="outlined"
                startIcon={<CloudUploadIcon />}
                sx={{ color: "#6750a4", backgroundColor: "#fff", width: "100%", borderRadius: '6px' }}
              >
                UPLOAD A NEW TOOL
              </Button>
            </CardActionArea>
            {openModal ? (
              <ClusterFileUpload
                uploadType={"TOOL"}
                handleClose={handleClose}
                openModal={openModal}
              />
            ) : null}
          </Grid>
        </Check>
      </Grid>
    </Fragment >
  );
};

ToolImageStats.defaultProps = {};

ToolImageStats.propTypes = {};

export default ToolImageStats;
